<div class="relative">
  <div class="rounded-xl bg-white dark:bg-gray-900 transition" [class.blur-sm]="isLoadingData()"
    [class.opacity-60]="isLoadingData()" [class.pointer-events-none]="isLoadingData()"
    [attr.aria-busy]="isLoadingData()">
    <form [formGroup]="scheduleForm">
      <div class="-mx-2.5 flex flex-wrap gap-y-5">
        <div class="w-full px-2.5">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" for="name">
            Título<span class="text-error-500">*</span>
          </label>
          <input type="text" placeholder="Ej: Mi Agenda personal" formControlName="name" id="name" name="name"
            class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30">
        </div>

        <div class="w-full px-2.5">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" for="description">
            Descripción
          </label>
          <input type="text" placeholder="Descripción" id="description" name="description" formControlName="description"
            class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30">
        </div>
        <div class="w-full px-2.5">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" for="name">
            Profesional<span class="text-error-500">*</span>
          </label>
          <div class="relative" *ngIf="!selectedClient(); else clientSelectedTpl">

            <span class="absolute top-1/2 left-4 -translate-y-1/2 text-gray-500 dark:text-gray-400">
              <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.0254 6.17845C8.0254 4.90629 9.05669 3.875 10.3289 3.875C11.601 3.875 12.6323 4.90629 12.6323 6.17845C12.6323 7.45061 11.601 8.48191 10.3289 8.48191C9.05669 8.48191 8.0254 7.45061 8.0254 6.17845ZM10.3289 2.375C8.22827 2.375 6.5254 4.07786 6.5254 6.17845C6.5254 8.27904 8.22827 9.98191 10.3289 9.98191C12.4294 9.98191 14.1323 8.27904 14.1323 6.17845C14.1323 4.07786 12.4294 2.375 10.3289 2.375ZM8.92286 11.03C5.7669 11.03 3.2085 13.5884 3.2085 16.7444V17.0333C3.2085 17.4475 3.54428 17.7833 3.9585 17.7833C4.37271 17.7833 4.7085 17.4475 4.7085 17.0333V16.7444C4.7085 14.4169 6.59533 12.53 8.92286 12.53H11.736C14.0635 12.53 15.9504 14.4169 15.9504 16.7444V17.0333C15.9504 17.4475 16.2861 17.7833 16.7004 17.7833C17.1146 17.7833 17.4504 17.4475 17.4504 17.0333V16.7444C17.4504 13.5884 14.8919 11.03 11.736 11.03H8.92286Z" />
              </svg>
            </span>

            <input type="search" placeholder="Busca por nombres, email, teléfono" formControlName="clientSearch"
              id="clientSearch" name="clientSearch" autocomplete="off"
              class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-3 pl-11 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30">


            <div *ngIf="(clientResults$ | async) as results"
              class="absolute z-20 mt-1 w-full rounded-lg border bg-white dark:bg-gray-900 dark:border-gray-700 shadow">
              <div *ngIf="results.length === 0" class="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">Sin
                resultados
              </div>
              <ul *ngIf="results.length > 0" class="max-h-64 overflow-auto">
                <li *ngFor="let c of results" (click)="selectClient(c)"
                  class="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800">
                  <img *ngIf="c.avatarUrl" [src]="c.avatarUrl" class="h-8 w-8 rounded-full" alt="">
                  <div *ngIf="!c.avatarUrl"
                    class="h-8 w-8 rounded-full bg-gray-200 dark:bg-gray-700 grid place-items-center text-xs text-gray-600 dark:text-gray-300">
                    👤</div>
                  <div class="min-w-0">
                    <div class="text-sm font-medium text-gray-800 dark:text-white/90">{{ c.firstName }} {{ c.lastName }}
                    </div>
                    <div class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ c.email }}</div>
                  </div>
                </li>
              </ul>
            </div>

          </div>
          <p class="text-theme-xs text-gray-500 mt-1.5">
            Selecciona al profesional al que se le asignará el horario.
          </p>
          @if(!selectedClient()){
          <div class="mt-2 flex justify-end">
            <button type="button" (pointerdown)="onCreateClient($event)"
              class="inline-flex items-center px-3 py-1.5 rounded-md text-sm bg-white text-brand-700 hover:bg-brand-100 dark:bg-gray-900 dark:border-gray-700">
              Crear profesional nuevo
            </button>
          </div>
          }

          <ng-template #clientSelectedTpl>
            <div class="flex items-center gap-3 p-2 rounded-lg border border-gray-300 dark:border-gray-700">
              <img *ngIf="selectedClient()?.avatarUrl" [src]="selectedClient()?.userId" class="h-9 w-9 rounded-full"
                alt="">
              <div *ngIf="!selectedClient()?.avatarUrl"
                class="h-9 w-9 rounded-full bg-gray-200 dark:bg-gray-700 grid place-items-center text-sm">👤</div>
              <div class="min-w-0 flex-1">
                <div class="text-sm font-medium text-gray-800 dark:text-white/90 truncate">
                  @if(selectedClient()?.firstName && selectedClient()?.lastName) {
                  {{ selectedClient()?.firstName }}
                  {{ selectedClient()?.lastName }}
                  } @else {
                  {{selectedClient()?.clientName}}
                  }
                </div>
                <div class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ selectedClient()?.email }}</div>
              </div>
              <!-- <button type="button"
                class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 dark:text-white" title="Ver perfil">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>

              </button> -->
              <button type="button" (click)="clearClient()"
                class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800  dark:text-white"
                title="Cambiar cliente">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                </svg>

              </button>
            </div>
          </ng-template>

        </div>

        <div class="w-full px-2.5">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
            Color<span class="text-error-500">*</span>
          </label>
          <div class="flex items-center gap-3">
            <input type="color" formControlName="color" inputmode="text" spellcheck="false" placeholder="#465FFF" class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10
             dark:focus:border-brand-800 h-11 w-40 rounded-lg border border-gray-300 bg-transparent
             px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden
             dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
            <p class="text-theme-md text-gray-500 mt-1.5 dark:text-white">
              {{scheduleForm.get('color')?.value}}
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<app-people-add-drawer
  [open]="drawerOpen"
  [endpoint]="'professionals'"
  [title]="'Nuevo Profesional'"
  (close)="onDrawerClose()"
  (created)="onProfessionalCreated($event)">
</app-people-add-drawer>
